module.exports = __webpack_public_path__ + "img/sv79on.3d2a7771.svg";